export const Paths = {
    home: '/',
    login: "",
    register: "",
    settings: '/settings',
    back: '/back'
  } as const;